const translations = {
  cz: {
    odebiratNovinky: 'Odebírat novinky',
    vasEmail: 'Váš e-mail',
    overenyZakaznik: 'Ověřený zákazník',
    precistClanek: 'Přečíst článek',
    minutaCteni: '1 min. čtení',
    minutyCteni: ' min. čtení',
    mintCteni: ' min. čtení',
    neniMozneZakoupitVice: 'Není možné zakoupit více než 9999 ks.',
    minimalniMnozstvi: 'Minimální množství, které lze zakoupit, je 1 ks.',
    zvysitMnozstvi: 'Zvýšit množství o 1',
    snizitMnozstvi: 'Snížit množství o 1',
    mnozstvi: 'Množství',
    precistClanek: 'Přečíst článek',
    jazykShopu: 'Čeština',
    hledatPlaceholder: 'Napište, co hledáte',
    mujucet: 'Můj účet',
    login: 'Uživatelské jméno nebo e-mail',
    heslo: 'Heslo',
    showAll: 'Ukázat vše',
    nejprodavanejsivkategorii: 'Nejprodávanější v této kategorii',
    detailTopProducts: 'Detail',
    sortingBy: 'Seřadit dle',
    cistVice: 'číst více',
    kod: 'Kód produktu',
    znacka: 'Značka',
    dorucitdo: 'Můžeme doručit do',
    parametry: 'Parametry',
    souvisejicisoubory: 'Dokumenty',
    videaproduktu: 'Související videa',
    podobneprodukty: 'Podobné',
    mohlobyzajimat: 'Mohlo by Vás zajímat',
    vsechnyVarianty: 'Všechny varianty produktu',
    code: 'Kód produktu',
    VlozitDoKosiku: 'Do košíku',
    rychlyNakup: 'Rychlý nákup',
    Zvoltevariantu: 'Zvolte variantu',
    varianta: 'další varianta',
    variant: 'dalších variant',
    varianty: 'další varianty',
    pridatdokosiku: 'Přidat do košíku',
    nevybranemnozstvi: 'Nevybrali jste žádné množství.',
    pridano: 'Celkem jste přidali',
    polozek: 'ks',
    slevatext: 'a získejte extra slevu',
    pouzijtekod: 'Použijte kód',
    cenapokodu: 'Cena po zadání kódu',
    prinakupunad: 'Při nákupu nad',
    ks: 'ks',
    kus: 'kus',
    kusu: 'kusů',
    nejlepsicena: 'Máte nejlepší možnou cenu.',
    nyninakupujete: 'Nyní nakupujete',
    za: 'za',
    pridejteJeste: 'Přidejte ještě',
    aziskate: 'a získáte cenu',
    od: 'od',
    cistMene: 'číst méně',
    filtrovaniProduktu: 'Filtrování produktů',
    loginTitle: 'Přihlášení',
    mnozstevniSlevy: 'Množstevní slevy',
    nynijsmeOnline: 'Nyní jsme online',
    po: 'Po',
    ut: 'Út',
    st: 'St',
    ct: 'Čt',
    pa: 'Pá',
    so: 'So',
    ne: 'Ne',
    fakturacni: 'Chci zadat fakturační adresu',
    koupit: 'Koupit',
    hlavickastav: 'Stav objednávky',
    statustext: 'Stav nákupu',
    slevovykupon: 'Slevový kupón',
    az: 'až',
    zoverenychplatforem: 'z ověřených platforem',
    recenze: 'recenze',
    recenzi: 'recenzí',
    notext: 'Zákazník nezanechal textovou recenzi.',
    nacistDalsi: 'Načíst další recenze',
    nacitam: 'Načítám...',
    vsechnyzdroje: 'Všechny zdroje',
    vsechnahodnoceni: 'Všechna hodnocení',
    zdrojrecenze: 'Zdroj recenze:',
    pocethvezd: 'Počet hvězdiček:',
    zakaznik: 'Ověřený zákazník',
    zobrazitOriginal: 'Zobrazit originál',
    zobrazitPreklad: 'Zobrazit překlad',
    zadneRecenzeNeOdpovidajiFiltru: "Žádné recenze neodpovídají filtru.",
    chyba: "Chyba:",
    blogNadpis: "Náš blog",
    vsechnyClanky: "Všechny články",
    darky: "Dárky",
    bezDph: "bez DPH",
  },
  nl: {
    odebiratNovinky: 'Abonneren',
    vasEmail: 'Uw e-mailadres',
    overenyZakaznik: 'Geverifieerde klant',
    precistClanek: 'Artikel lezen',
    minutaCteni: '1 min. lezen',
    minutyCteni: ' min. lezen',
    mintCteni: ' min. lezen',
    neniMozneZakoupitVice: 'Het is niet mogelijk om meer dan 9999 stuks te kopen.',
    minimalniMnozstvi: 'De minimale afname is 1 stuk.',
    zvysitMnozstvi: 'Aantal verhogen met 1',
    snizitMnozstvi: 'Aantal verlagen met 1',
    mnozstvi: 'Aantal',
    jazykShopu: 'Nederlands',
    hledatPlaceholder: 'Typ wat u zoekt',
    mujucet: 'Mijn account',
    login: 'Gebruikersnaam of e-mailadres',
    heslo: 'Wachtwoord',
    showAll: 'Alles tonen',
    nejprodavanejsivkategorii: 'Best verkocht in deze categorie',
    detailTopProducts: 'Detail',
    sortingBy: 'Sorteren op',
    cistVice: 'meer lezen',
    kod: 'Productcode',
    znacka: 'Merk',
    dorucitdo: 'Wij kunnen leveren vóór',
    parametry: 'Parameters',
    souvisejicisoubory: 'Documenten',
    videaproduktu: 'Gerelateerde video’s',
    podobneprodukty: 'Vergelijkbaar',
    mohlobyzajimat: 'Misschien ook interessant',
    vsechnyVarianty: 'Alle productvarianten',
    code: 'Productcode',
    VlozitDoKosiku: 'In winkelwagen',
    rychlyNakup: 'Snel kopen',
    Zvoltevariantu: 'Kies een variant',
    varianta: 'andere variant',
    variant: 'andere varianten',
    varianty: 'andere varianten',
    pridatdokosiku: 'Toevoegen aan winkelwagen',
    nevybranemnozstvi: 'U heeft geen aantal geselecteerd.',
    pridano: 'U heeft in totaal toegevoegd',
    polozek: 'st.',
    slevatext: 'en ontvang extra korting',
    pouzijtekod: 'Gebruik code',
    cenapokodu: 'Prijs na invoeren van de code',
    prinakupunad: 'Bij aankoop boven',
    ks: 'st.',
    kus: 'stuk',
    kusu: 'stuks',
    nejlepsicena: 'U heeft de best mogelijke prijs.',
    nyninakupujete: 'U koopt nu',
    za: 'voor',
    pridejteJeste: 'Voeg nog toe',
    aziskate: 'en ontvang de prijs',
    od: 'vanaf',
    cistMene: 'minder lezen',
    filtrovaniProduktu: 'Productfiltering',
    az: 'tot',
    loginTitle: 'Inloggen',
    mnozstevniSlevy: 'Staffelkorting',
    nynijsmeOnline: 'Nu online',
    po: 'Ma',
    ut: 'Di',
    st: 'Wo',
    ct: 'Do',
    pa: 'Vr',
    so: 'Za',
    ne: 'Zo',
    fakturacni: 'Ik wil een factuuradres invoeren',
    koupit: 'Kopen',
    hlavickastav: 'Bestelstatus',
    statustext: 'Status van de aankoop',
    zoverenychplatforem: 'van geverifieerde platforms',
    recenze: 'beoordeling',
    recenzi: 'beoordelingen',
    notext: 'De klant heeft geen tekstuele beoordeling achtergelaten.',
    nacistDalsi: 'Laad meer beoordelingen',
    nacitam: 'Laden...',
    vsechnyzdroje: 'Alle hulpbronnen',
    vsechnahodnoceni: 'Alle beoordelingen',
    zdrojrecenze: 'Bron bekijken:',
    pocethvezd: 'Aantal sterren:',
    zakaznik: 'Geverifieerde klant',
    zobrazitOriginal: 'Bekijk origineel',
    zobrazitPreklad: 'Toon vertaling',
    zadneRecenzeNeOdpovidajiFiltru: "Geen beoordelingen voldoen aan het filter.",
    chyba: "Fout:",
    slevovykupon: 'Kortingscode',
    blogNadpis: 'Onze blog',
    vsechnyClanky: 'Alle artikelen',
    darky: 'Cadeaus',
    bezDph: 'excl. btw',


  },
  de: {
    odebiratNovinky: 'Newsletter abonnieren',
    vasEmail: 'Ihre E-Mail',
    overenyZakaznik: 'Verifizierter Kunde',
    precistClanek: 'Artikel lesen',
    minutaCteni: '1 Min. Lesezeit',
    minutyCteni: ' Min. Lesezeit',
    mintCteni: ' Min. Lesezeit',
    neniMozneZakoupitVice: 'Es ist nicht möglich, mehr als 9999 Stk. zu kaufen.',
    minimalniMnozstvi: 'Die minimale Bestellmenge beträgt 1 Stk.',
    zvysitMnozstvi: 'Menge um 1 erhöhen',
    snizitMnozstvi: 'Menge um 1 verringern',
    mnozstvi: 'Menge',
    jazykShopu: 'Deutsch',
    hledatPlaceholder: 'Geben Sie ein, wonach Sie suchen',
    mujucet: 'Mein Konto',
    login: 'Benutzername oder E-Mail',
    heslo: 'Passwort',
    showAll: 'Alles anzeigen',
    nejprodavanejsivkategorii: 'Bestseller in dieser Kategorie',
    detailTopProducts: 'Detail',
    sortingBy: 'Sortieren nach',
    cistVice: 'mehr lesen',
    kod: 'Produktcode',
    znacka: 'Marke',
    dorucitdo: 'Lieferung bis',
    parametry: 'Parameter',
    souvisejicisoubory: 'Dokumente',
    videaproduktu: 'Zugehörige Videos',
    podobneprodukty: 'Ähnliche',
    mohlobyzajimat: 'Das könnte Sie interessieren',
    vsechnyVarianty: 'Alle Produktvarianten',
    code: 'Produktcode',
    VlozitDoKosiku: 'In den Warenkorb',
    rychlyNakup: 'Schnellkauf',
    Zvoltevariantu: 'Variante auswählen',
    varianta: 'weitere Variante',
    variant: 'weitere Varianten',
    varianty: 'weitere Varianten',
    pridatdokosiku: 'In den Warenkorb legen',
    nevybranemnozstvi: 'Sie haben keine Menge ausgewählt.',
    pridano: 'Sie haben insgesamt hinzugefügt',
    polozek: 'Stk.',
    slevatext: 'und erhalten Sie einen Extra-Rabatt',
    pouzijtekod: 'Code verwenden',
    cenapokodu: 'Preis nach Codeeingabe',
    prinakupunad: 'Bei einem Einkauf über',
    ks: 'Stk.',
    kus: 'Stück',
    kusu: 'Stück',
    nejlepsicena: 'Sie haben den bestmöglichen Preis.',
    nyninakupujete: 'Sie kaufen jetzt',
    za: 'für',
    pridejteJeste: 'Fügen Sie noch hinzu',
    aziskate: 'und erhalten Sie den Preis',
    od: 'ab',
    cistMene: 'weniger lesen',
    filtrovaniProduktu: 'Produktfilterung',
    loginTitle: 'Anmeldung',
    mnozstevniSlevy: 'Mengenrabatte',
    nynijsmeOnline: 'Jetzt online',
    po: 'Mo',
    ut: 'Di',
    st: 'Mi',
    ct: 'Do',
    pa: 'Fr',
    so: 'Sa',
    ne: 'So',
    fakturacni: 'Ich möchte eine Rechnungsadresse eingeben',
    koupit: 'Kaufen',
    hlavickastav: 'Bestellstatus',
    statustext: 'Status des Einkaufs',
    slevovykupon: 'Gutschein',
    az: 'bis',
    zoverenychplatforem: 'von verifizierten Plattformen',
    recenze: 'Bewertung',
    recenzi: 'Bewertungen',
    notext: 'Der Kunde hat keine Textbewertung hinterlassen.',
    nacistDalsi: 'Weitere Bewertungen laden',
    nacitam: 'Wird geladen...',
    vsechnyzdroje: 'Alle Quellen',
    vsechnahodnoceni: 'Alle Bewertungen',
    zdrojrecenze: 'Quelle der Bewertung:',
    pocethvezd: 'Anzahl der Sterne:',
    zakaznik: 'Verifizierter Kunde',
    zobrazitOriginal: 'Original anzeigen',
    zobrazitPreklad: 'Übersetzung anzeigen',
    zadneRecenzeNeOdpovidajiFiltru: "Keine Bewertungen entsprechen dem Filter.",
    chyba: "Fehler:",
    blogNadpis: 'Unser Blog',
    vsechnyClanky: 'Alle Artikel',
    darky: 'Geschenke',
    bezDph: 'ohne MwSt.',
  },
  pl: {
    odebiratNovinky: 'Subskrybuj nowości',
    vasEmail: 'Twój e-mail',
    overenyZakaznik: 'Zweryfikowany klient',
    precistClanek: 'Przeczytaj artykuł',
    minutaCteni: '1 min. czytania',
    minutyCteni: ' min. czytania',
    mintCteni: ' min. czytania',
    neniMozneZakoupitVice: 'Nie można kupić więcej niż 9999 szt.',
    minimalniMnozstvi: 'Minimalna ilość zakupu to 1 szt.',
    zvysitMnozstvi: 'Zwiększ ilość o 1',
    snizitMnozstvi: 'Zmniejsz ilość o 1',
    mnozstvi: 'Ilość',
    jazykShopu: 'Polski',
    hledatPlaceholder: 'Wpisz, czego szukasz',
    mujucet: 'Moje konto',
    login: 'Nazwa użytkownika lub e-mail',
    heslo: 'Hasło',
    showAll: 'Pokaż wszystko',
    nejprodavanejsivkategorii: 'Bestsellery w tej kategorii',
    detailTopProducts: 'Szczegóły',
    sortingBy: 'Sortuj według',
    cistVice: 'czytaj więcej',
    kod: 'Kod produktu',
    znacka: 'Marka',
    dorucitdo: 'Możemy dostarczyć do',
    parametry: 'Parametry',
    souvisejicisoubory: 'Dokumenty',
    videaproduktu: 'Powiązane wideo',
    podobneprodukty: 'Podobne',
    mohlobyzajimat: 'Może Cię zainteresować',
    vsechnyVarianty: 'Wszystkie warianty produktu',
    code: 'Kod produktu',
    VlozitDoKosiku: 'Do koszyka',
    rychlyNakup: 'Szybki zakup',
    Zvoltevariantu: 'Wybierz wariant',
    varianta: 'kolejny wariant',
    variant: 'kolejne warianty',
    varianty: 'kolejne warianty',
    pridatdokosiku: 'Dodaj do koszyka',
    nevybranemnozstvi: 'Nie wybrano ilości.',
    pridano: 'Łącznie dodano',
    polozek: 'szt.',
    slevatext: 'i zyskaj dodatkowy rabat',
    pouzijtekod: 'Użyj kodu',
    cenapokodu: 'Cena po użyciu kodu',
    prinakupunad: 'Przy zakupie powyżej',
    ks: 'szt.',
    kus: 'sztuka',
    kusu: 'sztuk',
    nejlepsicena: 'Masz najlepszą możliwą cenę.',
    nyninakupujete: 'Obecnie kupujesz',
    za: 'za',
    pridejteJeste: 'Dodaj jeszcze',
    aziskate: 'a otrzymasz cenę',
    od: 'od',
    cistMene: 'czytaj mniej',
    filtrovaniProduktu: 'Filtrowanie produktów',
    loginTitle: 'Logowanie',
    mnozstevniSlevy: 'Rabaty ilościowe',
    nynijsmeOnline: 'Nu online',
    po: 'Ma',
    ut: 'Di',
    st: 'Wo',
    ct: 'Do',
    pa: 'Vr',
    so: 'Za',
    ne: 'Zo',
    nynijsmeOnline: 'Jesteśmy online',
    po: 'Pon',
    ut: 'Wt',
    st: 'Śr',
    ct: 'Czw',
    pa: 'Pt',
    so: 'Sob',
    ne: 'Nd',
    fakturacni: 'Chcę podać adres rozliczeniowy',
    koupit: 'Kupić',
    hlavickastav: 'Status zamówienia',
    statustext: 'Status zakupu',
    slevovykupon: 'Kupon rabatowy',
    az: 'do',
    zoverenychplatforem: 'ze zweryfikowanych platform',
    recenze: 'opinia',
    recenzi: 'opinii',
    notext: 'Klient nie zostawił opinii tekstowej.',
    nacistDalsi: 'Załaduj więcej opinii',
    nacitam: 'Ładowanie...',
    vsechnyzdroje: 'Wszystkie źródła',
    vsechnahodnoceni: 'Wszystkie oceny',
    zdrojrecenze: 'Źródło opinii:',
    pocethvezd: 'Liczba gwiazdek:',
    zakaznik: 'Zweryfikowany klient',
    zobrazitOriginal: 'Pokaż oryginał',
    zobrazitPreklad: 'Pokaż tłumaczenie',
    zadneRecenzeNeOdpovidajiFiltru: "Żaden recenzja nie pasuje do filtru.",
    chyba: "Błąd:",
    blogNadpis: 'Nasz blog',
    vsechnyClanky: 'Wszystkie artykuły',
    darky: 'Prezenty',
    bezDph: 'bez VAT',
  },
  sk: {
    odebiratNovinky: 'Odoberať novinky',
    vasEmail: 'Váš e-mail',
    overenyZakaznik: 'Overený zákazník',
    precistClanek: 'Prečítať článok',
    minutaCteni: '1 min. čítania',
    minutyCteni: ' min. čítania',
    mintCteni: ' min. čítania',
    neniMozneZakoupitVice: 'Nie je možné zakúpiť viac ako 9999 ks.',
    minimalniMnozstvi: 'Minimálne množstvo na nákup je 1 ks.',
    zvysitMnozstvi: 'Zvýšiť množstvo o 1',
    snizitMnozstvi: 'Znížiť množstvo o 1',
    mnozstvi: 'Množstvo',
    jazykShopu: 'Slovenčina',
    hledatPlaceholder: 'Napíšte, čo hľadáte',
    mujucet: 'Môj účet',
    login: 'Používateľské meno alebo e-mail',
    heslo: 'Heslo',
    showAll: 'Zobraziť všetko',
    nejprodavanejsivkategorii: 'Najpredávanejšie v tejto kategórii',
    detailTopProducts: 'Detail',
    sortingBy: 'Zoradiť podľa',
    cistVice: 'čítať viac',
    kod: 'Kód produktu',
    znacka: 'Značka',
    dorucitdo: 'Môžeme doručiť do',
    parametry: 'Parametre',
    souvisejicisoubory: 'Dokumenty',
    videaproduktu: 'Súvisiace videá',
    podobneprodukty: 'Podobné',
    mohlobyzajimat: 'Mohlo by vás zaujímať',
    vsechnyVarianty: 'Všetky varianty produktu',
    code: 'Kód produktu',
    VlozitDoKosiku: 'Do košíka',
    rychlyNakup: 'Rychlý nákup',
    Zvoltevariantu: 'Zvoľte variant',
    varianta: 'ďalší variant',
    variant: 'ďalšie varianty',
    varianty: 'ďalšie varianty',
    pridatdokosiku: 'Pridať do košíka',
    nevybranemnozstvi: 'Nevybrali ste žiadne množstvo.',
    pridano: 'Celkovo ste pridali',
    polozek: 'ks',
    slevatext: 'a získate extra zľavu',
    pouzijtekod: 'Použite kód',
    cenapokodu: 'Cena po zadaní kódu',
    prinakupunad: 'Pri nákupe nad',
    ks: 'ks',
    kus: 'kus',
    kusu: 'kusov',
    nejlepsicena: 'Máte najlepšiu možnú cenu.',
    nyninakupujete: 'Teraz nakupujete',
    za: 'za',
    pridejteJeste: 'Pridajte ešte',
    aziskate: 'a získate cenu',
    od: 'od',
    cistMene: 'čítať menej',
    filtrovaniProduktu: 'Filtrovanie produktov',
    loginTitle: 'Prihlásenie',
    mnozstevniSlevy: 'Množstevné zľavy',
    nynijsmeOnline: 'Teraz online',
    po: 'Po',
    ut: 'Ut',
    st: 'St',
    ct: 'Št',
    pa: 'Pi',
    so: 'So',
    ne: 'Ne',
    fakturacni: 'Chcem zadať fakturačnú adresu',
    koupit: 'Kúpiť',
    hlavickastav: 'Stav objednávky',
    statustext: 'Stav nákupu',
    slevovykupon: 'Zľavový kupón',
    az: 'až',
    zoverenychplatforem: 'z overených platforiem',
    recenze: 'recenzia',
    recenzi: 'recenzií',
    notext: 'Zákazník nezanechal textovú recenziu.',
    nacistDalsi: 'Načítať ďalšie recenzie',
    nacitam: 'Načítavam...',
    vsechnyzdroje: 'Všetky zdroje',
    vsechnahodnoceni: 'Všetky hodnotenia',
    zdrojrecenze: 'Zdroj recenzie:',
    pocethvezd: 'Počet hviezdičiek:',
    zakaznik: 'Overený zákazník',
    zobrazitOriginal: 'Zobraziť originál',
    zobrazitPreklad: 'Zobraziť preklad',
    zadneRecenzeNeOdpovidajiFiltru: "Žiadna recenzia sa nezhoduje s filtrom.",
    chyba: "Chyba:",
    blogNadpis: 'Náš blog',
    vsechnyClanky: 'Všetky články',
    darky: 'Darčeky',
    bezDph: 'bez DPH',
  }
};

function translation(key) {
  const lang = $('html').attr('lang') || 'cz';
  const parts = key.split('.');
  const requestedLang = parts.length > 1 ? parts[0] : lang;
  const realKey = parts.length > 1 ? parts[1] : parts[0];
  return translations[requestedLang] && translations[requestedLang][realKey]
    ? translations[requestedLang][realKey]
    : translations['cz'][realKey] || key;
}